<ng-template #content let-modal>
	<div class="modal-header bg-{{tipo_color}}">
		<h4 class="modal-title text-{{letra_color}}">{{titulo}}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<p>{{mensaje}}</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-{{tipo_color}}" (click)="modal.close('Close click')">Cerrar</button>
	</div>
</ng-template>


<ng-template #content2 let-c="close" let-d="dismiss">
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Por favor espere...</h4>
		<!--button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button-->
	</div>
	<div class="modal-body align-self-center">
    <div class="spinner-border d-flex align-self-center" style="width: 3rem; height: 3rem; color: #016E97;" role="status">
        <span class="sr-only"></span>
    </div>
	</div>
	<!--div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="c('Save click')">Save</button>
	</div-->
</ng-template>


<ng-template #confirmacion let-modal>
	<div class="modal-header bg-primary">
		<h4 class="modal-title text-light">INFORMACIÓN</h4>
		<!--button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button-->
	</div>
	<div class="modal-body">
		<p>¿Desea realizar esta petición?</p>
	</div>
	<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="guardar()">Aceptar</button>
		<button type="button" class="btn btn-outline-secondary" (click)="modal.close('Close click')">Cerrar</button>
	</div>
</ng-template>
